import {
  ADD_APPENDIX,
  FILE_TYPE,
  IMPREST_ID
} from "../../../../../constants/filters";
import { FILE_TYPES } from "../../../../../constants/file";

export default (id, add_appendix) => {
  return filtersNormalize({ id, add_appendix });
};

const filtersNormalize = filters => {
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [IMPREST_ID]: filters.id,
    [ADD_APPENDIX]: filters.add_appendix
  };
};
